import { isSafariOnNonRetina } from './clientOnly'

export const flattenNestedSvg = (
	svgMarkup: string,
	{
		x,
		y,
		width,
		height,
	}: {
		x: number
		y: number
		width: number
		height: number
	},
): string => {
	const svgOpenTagMatch = svgMarkup.match(/<svg([^>]*)>/i)
	if (!svgOpenTagMatch?.[1]) {
		return svgMarkup
	}

	const svgAttributes = svgOpenTagMatch[1]

	const viewBoxMatch = svgAttributes.match(/viewBox="([\d.\s-]+)"/i)
	if (!viewBoxMatch?.[1]) {
		return svgMarkup
	}

	const viewBox = viewBoxMatch[1].split(/\s+/).map(Number)
	const [, , vbWidth, vbHeight] = viewBox

	const scaleX = width / vbWidth!
	const scaleY = height / vbHeight!

	const innerContent = svgMarkup
		.replace(/<svg[^>]*>/i, '')
		.replace(/<\/svg>/i, '')

	const transform = `translate(${x}, ${y}) scale(${scaleX}, ${scaleY})`

	const shouldEnableCrispEdges =
		typeof window === 'undefined' || !isSafariOnNonRetina()

	return `<g ${shouldEnableCrispEdges ? 'shape-rendering="crispEdges"' : ''} transform="${transform}">${innerContent}</g>`
}
